<template>
  <div class="publishSurvey-forms" v-loading="isLoading">
    <div class="table" v-loading="publishSurveyLoading">
      <!-- 调查表基础信息 -->
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
        <el-form-item label="选择模版">
          <el-col :span="11">
            <el-select v-model="ruleForm.selectedQuestionnaireType" filterable placeholder="请选择模版分类"
              @change="questionnaireTypeChange" clearable style="width: 200px;">
              <el-option v-for="item in questionnaireTypeList" :key="item.dictValue" :label="item.dictLabel"
                :value="item.dictValue">
              </el-option>
            </el-select>
          </el-col>
          <el-col class="line" :span="2">-</el-col>
          <el-col :span="11">
            <el-select v-model="selectedTemplateId" filterable placeholder="请选择模版" @change="templateTypeChange"
              clearable style="width: 200px">
              <el-option v-for="item in templateTypeList" :key="item.id" :label="item.formName" :value="item.id">
              </el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="调查表名称" prop="formName">
          <el-input v-model="ruleForm.formName"></el-input>
        </el-form-item>
        <el-form-item label="调查表说明" prop="description">
          <!-- <el-input type="textarea" v-model="ruleForm.description"></el-input> -->
          <vue-editor v-model="ruleForm.description" :editor-toolbar="customToolbar" />
        </el-form-item>
        <el-form-item label="年级班级">
          <el-col :span="11">
            <el-form-item prop="gradeName">
              <el-select v-model="ruleForm.gradeName" placeholder="请选择年级" @change="selectGrade" clearable
                style="width: 200px">
                <el-option v-for="item in gradeSelectList" :key="item.gradeId" :label="item.gradeName"
                  :value="item.gradeId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col class="line" :span="2">-</el-col>
          <el-col :span="11">
            <el-form-item prop="className">
              <el-select v-model="ruleForm.className" placeholder="选择班级" @change="selectClass" clearable>
                <el-option v-for="item in classSelectList" :key="item.classId" :label="item.className"
                  :value="item.classId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="起止时间" required>
          <el-col :span="11">
            <el-form-item prop="startTime">
              <el-date-picker v-model="ruleForm.startTime" type="date" placeholder="开始时间" style="width: 200px"
                format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col class="line" :span="2">-</el-col>
          <el-col :span="11">
            <el-form-item prop="endTime">
              <el-date-picker v-model="ruleForm.endTime" type="date" placeholder="截止时间" style="width: 100%"
                format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-form-item>
      </el-form>
      <el-divider></el-divider>
      <!-- 调查表问题列表 -->
      <el-form v-for="(item, index) in questionList" :key="index" label-width="100px">
        <el-form-item :label="index + 1 + '.问题标题'" :label-position="labelPosition" required>
          <el-input v-model="item.title"></el-input>
        </el-form-item>
        <el-form-item label="说明">
          <el-input type="textarea" v-model="item.description"></el-input>
        </el-form-item>
        <el-form-item label="顺序" :label-position="labelPosition" required>
          <el-input v-model="item.sequence" type="number"></el-input>
        </el-form-item>
        <el-form-item label="是否必填" :label-position="labelPosition">
          <el-switch v-model="item.isRequiredStatus" @change="isRequiredChange($event, item)"></el-switch>
        </el-form-item>
        <el-form-item label="回答类型" required>
          <el-select v-model="item.problemType" placeholder="请选择类型">
            <el-option v-for="(item, index) in questionTypeList" :key="index" :label="item.dictLabel"
              :value="item.dictValue"></el-option>
          </el-select>
        </el-form-item>
        <div class="option-list" v-if="item.problemType !== '' &&
          item.problemType !== '4' &&
          item.problemType !== '5'
        ">
          <div class="option-item" v-for="(oItem, oIndex) in item.surveyOptionsList" :key="oIndex">
            {{ oIndex + 1 }}.
            <el-input v-model="oItem.optionContent" type="optionContent" placeholder="请输入选项名称" />
            <i class="el-icon-remove-outline" @click="delOption(item, oIndex)"></i>
          </div>
        </div>
        <div class="add-option" @click="addOption(item)" v-if="item.problemType !== '' &&
          item.problemType !== '4' &&
          item.problemType !== '5'
        ">
          <el-button type="text" icon="el-icon-circle-plus-outline">添加选项</el-button>
        </div>
        <el-divider></el-divider>
      </el-form>
      <div class="btn-list">
        <el-button type="primary" @click="submit('ruleForm')">创建</el-button>
        <el-button type="primary" @click="previewClick('ruleForm')">预览</el-button>
        <el-button type="primary" @click="addProblem">添加</el-button>
        <el-button type="primary" @click="delProblem">删除</el-button>
      </div>
    </div>
    <previewDialog v-show="previewDialogVisible" :previewDialogVisible.sync="previewDialogVisible" :ruleForm="ruleForm"
      :questionList="questionList" ref="previewDialog" />
  </div>
</template>

<script>
import previewDialog from "../preview-dialog/previewDialog.vue";
import { VueEditor } from "vue2-editor";
export default {
  props: ["questionTypeList", "gradeSelectList", "templateTypeList", "questionnaireTypeList"],
  components: {
    previewDialog, VueEditor
  },
  data() {
    return {
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        [{ color: [] }, { background: [] }],
        [{ align: [] }],
        ["clean"],
      ],
      // 发布调查表加载状态
      publishSurveyLoading: false,
      // 预览弹窗
      previewDialogVisible: false, // 预览弹窗
      // 班级下拉列表
      classSelectList: [],
      // 问题列表
      questionList: [],
      // 加载状态
      isLoading: false,
      // 标签位置
      labelPosition: "left",
      selectedTemplateId: '', // 绑定 select
      // 表单数据
      ruleForm: {
        formName: "",
        description: "",
        startTime: "",
        endTime: "",
        gradeId: "",
        gradeName: "",
        classId: "",
        className: "",
        templateType: '', // 提交时根据 selectedTemplateId 决定
        selectedQuestionnaireType: '',
      },
      // 表单规则
      rules: {
        formName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
        ],
        startTime: [
          {
            required: true,
            message: "请选择时间",
            trigger: "change",
          },
        ],
        endTime: [
          {
            required: true,
            message: "请选择时间",
            trigger: "change",
          },
        ],
        description: [
          { required: true, message: "请填写说明", trigger: "blur" },
        ],
      },
    };
  },
  // 注入refresh函数
  inject: ["refresh"],
  created() {
    // 确保初始 templateType 是非1的随机数
    this.$nextTick(() => {
      if (!this.ruleForm.templateType || this.ruleForm.templateType === '1') {
        this.ruleForm.templateType = this.getRandomNonOne().toString();
      }
    });
  },
  methods: {
    questionnaireTypeChange(e) {
      // console.log(e);
      this.$emit("questionnaireTypeChange", e);
    },
    // 生成一个除了1以外的随机整数（比如 2-100 之间）
    getRandomNonOne() {
      const min = 2;
      const max = 1000000000000000;
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    templateTypeChange(e) {
      if (!e) {
        // 没有选择模板：清空数据，templateType 设为非1的随机数
        this.questionList = [];
        this.ruleForm = {
          formName: "",
          description: "",
          startTime: "",
          endTime: "",
          gradeId: "",
          gradeName: "",
          classId: "",
          className: "",
          templateType: this.getRandomNonOne().toString() // 随机非1
        };
        return;
      }

      // 选择了模板：拉取模板数据，并设置 templateType 为 '1'
      this.get(this.$url.selectQuestionnaireFormDetail + "/" + e).then((res) => {
        if (res.code !== 200) return this.$message.error(res.msg);

        this.ruleForm.formName = res.data[0].formName;
        this.ruleForm.description = res.data[0].description;
        this.ruleForm.templateType = '1'; // 明确设为 1
        this.questionList = res.data[0].surveyQuestionsList.map((item, index) => ({
          ...item,
          isRequiredStatus: item.isRequired === '1',
          sequence: item.ssqSequence
        }));
      });
    },
    // 提交表单
    submit(formName) {
      // 表单验证
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 检查问题列表是否为空
          if (!this.questionList.length)
            return this.$message.warning("请添加调查表问题");
          // 检查是否补充完整
          const someAreNotEmpty = this.checkEmptyValues(this.questionList);

          if (!someAreNotEmpty) {
            return this.$message.warning("请补充完整信息");
          }

          // 将加载状态修改为true
          this.publishSurveyLoading = true;

          // 获取表单数据
          let { formName, description, startTime, endTime, classId, gradeId, templateType } =
            this.ruleForm;

          // data中的数据去除空格符
          let data = {
            formName: formName.replace(/\s/g, ""),
            description: description.replace(/\s/g, ""),
            startTime,
            endTime,
            schoolId: this.user.schoolId,
            templateType,
            surveyQuestionsList: this.questionList.map((question) => ({
              ...question,
              title: question.title.replace(/\s/g, ""),
              description: question.description.replace(/\s/g, ""),
              surveyOptionsList: question.surveyOptionsList.map(
                (surveyQuestion) => ({
                  ...surveyQuestion,
                  sequence: surveyQuestion.ssoSequence || surveyQuestion.sequence,
                  optionContent: surveyQuestion.optionContent.replace(
                    /\s/g,
                    ""
                  ),
                })
              ),
            })),
          };

          // 判断是否传入gradeId
          if (gradeId !== "") {
            data.gradeId = gradeId;
          }

          // 判断是否传入classId
          if (classId !== "") {
            data.classId = classId;
          }

          // 发送请求
          this.post(this.$url.addSurveyForms, data).then((res) => {
            // console.log("添加调查表==》", res);
            // 将加载状态修改为false
            this.publishSurveyLoading = false;
            // 判断请求是否成功
            if (res.code !== 200) return this.$message.error(res.msg);

            // 添加成功，提示成功信息
            this.$message.success(res.msg);

            // 刷新页面
            this.refresh();

            // 清空表单数据
            this.ruleForm = {
              formName: "",
              description: "",
              startTime: "",
              endTime: "",
              gradeId: "",
              gradeName: "",
              classId: "",
              className: "",
              templateType: this.getRandomNonOne().toString(), // 随机非1
              selectedQuestionnaireType: ''
            };
            this.selectedTemplateId = '';
            this.questionList = [];

            // 触发添加成功事件
            this.$emit("addSurveyForms");
          });
        } else {
          return false;
        }
      });
    },
    previewClick(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.questionList.length)
            return this.$message.warning("请添加调查表问题");
          const someAreNotEmpty = this.checkEmptyValues(this.questionList);

          if (!someAreNotEmpty) {
            return this.$message.warning("请补充完整信息");
          }
          let questionList = JSON.parse(JSON.stringify(this.questionList));
          // 假设 this.questionList 是一个包含数据的数组
          this.$refs.previewDialog.questionList = questionList.sort((a, b) => {
            // 将 sequence 字符串转换为数值进行比较
            const sequenceA = parseInt(a.sequence);
            const sequenceB = parseInt(b.sequence);

            // 如果转换失败，使用默认字符串比较
            const compareA = isNaN(sequenceA) ? a.sequence : sequenceA;
            const compareB = isNaN(sequenceB) ? b.sequence : sequenceB;

            // 返回比较结果
            return compareA - compareB;
          });

          console.log("questionList:", questionList);

          this.previewDialogVisible = true;
        } else {
          return false;
        }
      });
    },
    // 检测对象数组中是否有属性值为空
    checkEmptyValues(list) {
      for (const item of list) {
        for (const key in item) {
          if (
            key !== "description" &&
            key !== "isRequiredStatus" &&
            key !== "val" &&
            key !== "checkedVal" && key !== "answerContent"
          ) {
            if (item.hasOwnProperty(key) && !item[key]) {
              return false;
            }
          }
        }
      }
      return true;
    },
    addProblem() {
      this.questionList.push({
        title: "", // 问题标题
        description: "", // 描述
        sequence: this.questionList.length + 1, // 顺序
        problemType: "", // 回答类型
        isRequired: "0",
        isRequiredStatus: false,
        val: "",
        checkedVal: [],
        surveyOptionsList: [],
      });
    },
    delProblem() {
      if (this.questionList.length <= 1)
        return this.$message.warning("已到最小限制数,请勿点击删除");
      this.questionList.pop();
      this.$notify({
        type: "success",
        title: "删除表单问题",
        message: "删除成功",
        position: "bottom-right",
      });
    },
    // 问题类型为单选多选下拉时点击添加选项
    addOption(item) {
      item.surveyOptionsList.push({
        optionContent: "",
        sequence: item.surveyOptionsList.length + 1,
      });
    },
    delOption(item, index) {
      item.surveyOptionsList.splice(index, 1);
    },
    selectGrade(e) {
      this.ruleForm.className = "";
      this.ruleForm.gradeId = e;
      if (e !== "") {
        this.classSelectList = this.gradeSelectList.find(
          (item) => item.gradeId == e
        ).schoolClassList;
      } else {
        this.gradePlaceholder = "请选择年级";
        this.classSelectList = [];
      }
    },
    selectClass(e) {
      this.ruleForm.classId = e;
    },
    isRequiredChange(e, item) {
      item.isRequired = e ? "1" : "0";
    },
  },
};
</script>

<style scoped lang="scss">
@import "./publishSurveyForms.scss";
</style>
